module.exports = __webpack_public_path__ + "static/media/mn13.3d10e7d2.jpeg";